/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ESickNoteNpAttendingDoctorSchema } from '../models/ESickNoteNpAttendingDoctorSchema';
import type { ESickNoteNpBenefitKind } from '../models/ESickNoteNpBenefitKind';
import type { ESickNoteNpCareCaseDetailSchema } from '../models/ESickNoteNpCareCaseDetailSchema';
import type { ESickNoteNpCsszCaseDetailSchema } from '../models/ESickNoteNpCsszCaseDetailSchema';
import type { ESickNoteNpCsszSubmissionListSchema } from '../models/ESickNoteNpCsszSubmissionListSchema';
import type { ESickNoteNpLongTermCareCaseDetailSchema } from '../models/ESickNoteNpLongTermCareCaseDetailSchema';
import type { ESickNoteNpUnclosedCsszCaseSchema } from '../models/ESickNoteNpUnclosedCsszCaseSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EsickNotesNpApi {
    /**
     * Get Esick Note Np Cssz Submission List
     * List care and long-term care submissions ČSSZ holds for this identity, optionally by cared-for person or decision number; cancelled cases and cases with a paper submission are listed too (ČSSZ IkreNpVratPodani). Required Permission: create_esick_note
     * @returns ESickNoteNpCsszSubmissionListSchema OK
     * @throws ApiError
     */
    public static esickNoteNpGetEsickNoteNpCsszSubmissionListGet({
        identityId,
        caredPersonNin,
        decisionNumber,
        benefitKind,
        start,
        count,
    }: {
        identityId: string,
        /**
         * RČ/EČP of the cared-for person (DleRc).
         */
        caredPersonNin?: (string | null),
        /**
         * Decision number (DleCislaRozhodnuti).
         */
        decisionNumber?: (string | null),
        benefitKind?: (ESickNoteNpBenefitKind | null),
        start?: (number | null),
        count?: (number | null),
    }): CancelablePromise<ESickNoteNpCsszSubmissionListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/np/identities/{identity_id}/submissions/',
            path: {
                'identity_id': identityId,
            },
            query: {
                'cared_person_nin': caredPersonNin,
                'decision_number': decisionNumber,
                'benefit_kind': benefitKind,
                'start': start,
                'count': count,
            },
        });
    }
    /**
     * Get Esick Note Np Cssz Case Detail
     * Read a care or long-term care case as ČSSZ currently holds it, including its state and whether this identity is still its attending doctor (ČSSZ IkreNpVratDetailPripadu). Required Permission: create_esick_note
     * @returns ESickNoteNpCsszCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpGetEsickNoteNpCsszCaseDetailGet({
        identityId,
        decisionNumber,
    }: {
        identityId: string,
        decisionNumber: string,
    }): CancelablePromise<ESickNoteNpCsszCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/np/identities/{identity_id}/cases/{decision_number}/',
            path: {
                'identity_id': identityId,
                'decision_number': decisionNumber,
            },
        });
    }
    /**
     * Get Unclosed Esick Note Np Cssz Case List
     * Search ČSSZ for open care and long-term care cases, including ones issued by other doctors, by cared-for person's national id or decision number. Used before taking a case over (ČSSZ IkreNpVratNeukonceneNp). Required Permission: create_esick_note
     * @returns ESickNoteNpUnclosedCsszCaseSchema OK
     * @throws ApiError
     */
    public static esickNoteNpGetUnclosedEsickNoteNpCsszCaseListGet({
        identityId,
        caredPersonNin,
        decisionNumber,
    }: {
        identityId: string,
        /**
         * RČ/EČP of the cared-for person (DleRc).
         */
        caredPersonNin?: (string | null),
        /**
         * Decision number (DleCislaRozhodnuti).
         */
        decisionNumber?: (string | null),
    }): CancelablePromise<Array<ESickNoteNpUnclosedCsszCaseSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/np/identities/{identity_id}/unclosed-cases/',
            path: {
                'identity_id': identityId,
            },
            query: {
                'cared_person_nin': caredPersonNin,
                'decision_number': decisionNumber,
            },
        });
    }
    /**
     * Set Esick Note Np Attending Doctor
     * Take a care or long-term care case issued by another doctor into this identity's care and start tracking it locally (ČSSZ IkreNpVratNeukonceneNp + HolNp PrevzetiDoPece). The response has the shape of the case's benefit kind. Required Permission: create_esick_note
     * @returns any OK
     * @throws ApiError
     */
    public static esickNoteNpSetEsickNoteNpAttendingDoctorPut({
        identityId,
        decisionNumber,
        requestBody,
    }: {
        identityId: string,
        decisionNumber: string,
        requestBody: ESickNoteNpAttendingDoctorSchema,
    }): CancelablePromise<(ESickNoteNpCareCaseDetailSchema | ESickNoteNpLongTermCareCaseDetailSchema)> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/esick-notes/np/identities/{identity_id}/cases/{decision_number}/attending-doctor/',
            path: {
                'identity_id': identityId,
                'decision_number': decisionNumber,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
